// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-field-captcha{margin-top:var(--spacer-half);margin-bottom:var(--spacer-4)}.form-field-captcha.is-invalid{border:unset!important}.form-field-captcha>div{margin:0 auto}", ""]);
// Exports
module.exports = exports;
